import { fetchTermsOfUse, fetchPrivacyPolicy } from 'app/actions/terms-management.actions';

import template from './terms-management.html';

const DEFAULT_TAB_ID = 'termsOfUse';

const mapDispatchToThis = {
  fetchTermsOfUse,
  fetchPrivacyPolicy,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class TermsManagementController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(null, mapDispatchToThis)(this);
  }

  $onInit() {
    this.onTabSelect(DEFAULT_TAB_ID);
  }

  $onDestroy() {
    this.unsubscribe();
  }


  onTabSelect(tabId) {
    this.activeTabId = tabId;
  }
}

export default class TermsManagementComponent {
  constructor() {
    this.controller = TermsManagementController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/terms/terms-management-component.js